module.exports = __webpack_public_path__ + "static/media/remove.1d2a6e09.svg";